import { lazy, Suspense } from "react";
import Loader from "../custom/loader/main";

const Main = lazy(
  () => import("../components/certificate/processedCertificate")
);

const ProcessedCertificate = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ProcessedCertificate;
